import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link as ReactRouterLink } from "react-router-dom";
//@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Loading,
    Row,
    Panel,
    useAddToast,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import { LinkForm, Link } from "../../forms/LinkForm";
import { HeaderEmphasis, TabordionGroup } from "../../components/index";

export const LinkEdit = ({ uuid, path }) => {
    const page = useQueryString().get("page");
    const addToast = useAddToast();

    const [tab, setTab] = useState(0);
    const [item, setItem] = useState<{ loaded: boolean; data?: Link }>({
        loaded: false,
        data: null,
    });
    const getItem = () => {
        setTab(0);
        setItem({ loaded: false, data: null });
        axios.get(`/api/v1/admin/link/${uuid}`).then(({ data }) => {
            setItem({ loaded: true, data: data.data });
        });
    };

    useEffect(getItem, [uuid]);

    const submitForm = (values, setSubmitting) => {
        return axios
            .post(`/api/v1/admin/link/${uuid}`, values)
            .then(({ data }) => {
                addToast({
                    type: "success",
                    content: trans("Link updated"),
                    showFor: 5000,
                });
                setSubmitting(false);
                setItem({
                    loaded: true,
                    data: data.data,
                });

                //As creation was successful move them on to the edit page
                // history.push(`${path}/edit/${data.uuid}`);
            });
    };

    return (
        <div>
            <PageTitle
                title={
                    <React.Fragment>
                        {trans("Edit Link")}{" "}
                        <HeaderEmphasis>
                            {item.data ? item.data.name : ""}
                        </HeaderEmphasis>
                    </React.Fragment>
                }
            >
                <IconTextButton
                    as={ReactRouterLink}
                    to={`${path}?page=${page ? page : 1}`}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>
            {item.loaded ? (
                <Row>
                    <Panel style={{ paddingBottom: "0" }}>
                        <LinkForm item={item.data} submitForm={submitForm} />
                    </Panel>
                </Row>
            ) : (
                <Loading />
            )}
        </div>
    );
};

export default LinkEdit;
